import React from 'react';
import Image from 'next/image';

import { Colors } from 'enums/Colors';
import Symbol from 'assets/logotype/symbol.svg';
import { MovieModal } from 'components/MovieModal';

import styles from './HowItWorks.module.scss';

interface Props {
  heading: string;
  imageSrc?: string;
  alt?: string;
  imageVariant?: 'none' | 'fill' | 'centered' | 'movie';
  color?: Colors;
}

export const HowItWorks: React.FC<Props> = ({
  heading,
  imageSrc,
  alt = '',
  imageVariant = 'fill',
  color = Colors.SkyBlue,
  children,
}) => (
  <div
    className={`${styles.container} ${styles[color]} ${styles[imageVariant]}`}
    style={{ backgroundColor: `var(--color-${color})` }}
  >
    <Symbol className={`${styles.symbol} ${styles[color]}`} />
    {imageSrc && imageVariant !== 'none' && (
      <div className={styles.image}>
        <Image
          alt={alt}
          src={imageSrc}
          layout="fill"
          objectFit={imageVariant === 'centered' ? 'contain' : 'cover'}
          quality={90}
        />
      </div>
    )}
    {!imageSrc && imageVariant === 'movie' && (
      <div className={styles.movie}>
        <MovieModal src="/assets/images/movie-cover.png">
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video controls className={styles.player} autoPlay style={{ width: '100%' }}>
            <source src="/assets/movies/trailer.webm" type="video/webm" />
            <source src="/assets/movies/trailer.mp4" type="video/mp4" />
            Sorry, your browser doesn&apos;t support embedded videos.
          </video>
        </MovieModal>
      </div>
    )}
    <div className={styles.content}>
      <h2 className={styles.heading}>{heading}</h2>
      <div className={styles.children}>{children}</div>
    </div>
  </div>
);
